import { render, staticRenderFns } from "./UsuariosServentia.vue?vue&type=template&id=27f1e38b&"
import script from "./UsuariosServentia.vue?vue&type=script&lang=js&"
export * from "./UsuariosServentia.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosServentia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports